// Comboboxes and date pickers can't take focus, so react-hook-form won't
// scroll to them on a failed submit; bring the first error message into view
export function scrollToFirstError(formElement?: HTMLElement | null) {
    requestAnimationFrame(() =>
        formElement
            ?.querySelector(".text-destructive:not(:empty)")
            ?.scrollIntoView({ behavior: "smooth", block: "center" }),
    );
}
